import {
	VirtualTable,
	NumberOfTicketSplit,
	OrderType,
	TicketType,
	TicketStatusFilter,
	TicketStatus,
} from "@royalty/model";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
export class PosHelper {
	public static listVirtualTable(): VirtualTable[] {
		const virtualTables: VirtualTable[] = [
			{ id: 1, tableAlias: "A" },
			{ id: 2, tableAlias: "B" },
			{ id: 3, tableAlias: "C" },
			{ id: 4, tableAlias: "D" },
			{ id: 5, tableAlias: "E" },
			{ id: 6, tableAlias: "F" },
			{ id: 7, tableAlias: "G" },
			{ id: 8, tableAlias: "H" },
			{ id: 9, tableAlias: "I" },
			{ id: 10, tableAlias: "J" },
			{ id: 11, tableAlias: "K" },
			{ id: 12, tableAlias: "L" },
		];
		return virtualTables;
	}

	static numberTicketSplit(): NumberOfTicketSplit[] {
		const numberOfTicketSplits: NumberOfTicketSplit[] = [];
		this.listVirtualTable().forEach((table) => {
			const numberOfTicketSplit: NumberOfTicketSplit = {
				id: table.id,
				name: table.tableAlias,
				active: false,
				isFree: true,
				hasItem: false,
				ticketDetail: null,
			};
			numberOfTicketSplits.push(numberOfTicketSplit);
		});
		return numberOfTicketSplits;
	}

	static ticketStatusFilters() {
		const paymentStatus: TicketStatusFilter[] = [
			{
				type: null,
				name: "Open",
				active: false,
				ticketStatus: [
					TicketStatus.Open,
					TicketStatus.Saved,
					TicketStatus.BillPrinted,
					TicketStatus.BillPartialPrinted,
					TicketStatus.Refunded,
					TicketStatus.Reopened,
					TicketStatus.Waiting,
				],
			},
			{
				type: null,
				name: "All",
				active: false,
				ticketStatus: [
					TicketStatus.Open,
					TicketStatus.Saved,
					TicketStatus.BillPrinted,
					TicketStatus.BillPartialPrinted,
					TicketStatus.Refunded,
					TicketStatus.Reopened,
					TicketStatus.Waiting,
					TicketStatus.Release,
				],
			},
			// {
			// 	type: null,
			// 	name: "Paid",
			// 	active: false,
			// 	ticketStatus: [TicketStatus.PaidAndReopen, TicketStatus.Paid],
			// },
			{
				type: null,
				name: "Cash",
				active: false,
				ticketStatus: [
					TicketStatus.Closed,
					TicketStatus.PaidAndClosed,
					TicketStatus.Voided,
				],
			},
			{
				type: null,
				name: "Waiting",
				active: false,
				ticketStatus: [
					TicketStatus.Closed,
					TicketStatus.PaidAndClosed,
					TicketStatus.PaidAndReopen,
					TicketStatus.Voided,
				],
			},
			{
				type: null,
				name: "Release",
				active: false,
				ticketStatus: [
					TicketStatus.Closed,
					TicketStatus.PaidAndClosed,
					TicketStatus.Voided,
				],
			},
			{
				type: null,
				name: "Pending",
				active: false,
				ticketStatus: [
					TicketStatus.Closed,
					TicketStatus.PaidAndClosed,
					TicketStatus.Voided,
				],
			},
			{
				type: null,
				name: "Void",
				active: false,
				ticketStatus: [
					TicketStatus.Voided,
				],
			},
		];
		return paymentStatus;
	}

	static orderTypes() {
		const orderTypes: OrderType[] = [
			{ ticketType: null, name: "All", active: false },
			{ ticketType: TicketType.DINE_IN, name: "Dine In", active: false },
			{
				ticketType: TicketType.TAKE_OUT,
				name: "Take Out",
				active: false,
			},
		];
		return orderTypes;
	}

	static convertTableIds(tables: string): number[] {
		const ids: number[] = [];
		if (tables) {
			const tbls = tables.split(",");
			if (tbls) {
				tbls.forEach((id) => {
					ids.push(Number(id));
				});
			}
		}
		return ids;
	}

	static isArrayWithLength(array: any): boolean {
		return Boolean(Array.isArray(array) && array.length);
	}

	static getIds(array: any): number[] {
		if (this.isArrayWithLength(array)) {
			return array.filter((x) => x.id > 0).map((x) => x.id);
		}
		return null;
	}

	static getFirstElement(array: any): any {
		if (PosHelper.isArrayWithLength(array)) return array[0];
		return null;
	}

	static getLastItemInArray(array: any) {
		if (this.isArrayWithLength(array)) return array[array.length - 1];
		else return null;
	}

	static convertCommaToNumber(value: any): number {
		return value ? Number((value + "").replace(",", ".")) : null;
	}

	static scrollItemIntoView(elemId: string): void {
		setTimeout(() => {
			// Scroll to item selected when go up/down
			const itemRef = document.getElementById(elemId) as HTMLElement;
			if (itemRef) {
				itemRef.scrollIntoView({
					behavior: "smooth",
					block: "center",
					inline: "center",
				});
			}
		}, 0);
	}

	static convertCurrencyToNumber(currency: any): number {
		return Number((currency + "").replace(/[^0-9.-]+/g, ""));
	}

	static createNumberMask() {
		return createNumberMask({
			prefix: "",
			suffix: "",
			allowDecimal: true,
		});
	}

	static createVndNumberMask() {
		return createNumberMask({
			prefix: "",
			suffix: "",
			allowDecimal: true,
			thousandsSeparatorSymbol: ".",
			decimalSymbol: ",",
			decimalLimit: 2,
		});
	}

	static secondsToHms(d: any) {
		d = Number(d);
		const h = Math.floor(d / 3600);
		const m = Math.floor((d % 3600) / 60);
		const s = Math.floor((d % 3600) % 60);
		const hDisplay = h > 0 ? h + (h == 1 ? " hour " : " hours ") : "";
		const mDisplay = m > 0 ? m + (m == 1 ? " minute " : " minutes ") : "";
		const sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
		return hDisplay + mDisplay + sDisplay;
	}

	static checkCurrentDateBetweenTwosDate(dateFrom: string, dateTo: string) {
		var dateCheck = new Date();

		var from = new Date(dateFrom + " 00:00:00");
		var to = new Date(dateTo + " 23:59:59");
		return dateCheck >= from && dateCheck <= to;
	}

	static checkCurrentDateTimeBetweenTwosDateTime(
		dateFrom: string,
		timeFrom: string,
		dateTo: string,
		timeTo: string
	) {
		var dateCheck = new Date();

		var from = new Date(dateFrom + " " + timeFrom);
		var to = new Date(dateTo + " " + timeTo);
		console.log(from, dateCheck, to);
		return dateCheck >= from && dateCheck <= to;
	}

	static checkCurrentTimeBetweenTwosTime(startTime: string, endTime: string) {
		let currentDate = new Date();
		let startDate = new Date(currentDate.getTime());

		startDate.setHours(parseInt(startTime.split(":")[0]));
		startDate.setMinutes(parseInt(startTime.split(":")[1]));
		startDate.setSeconds(0);

		let endDate = new Date(currentDate.getTime());
		endDate.setHours(parseInt(endTime.split(":")[0]));
		endDate.setMinutes(parseInt(endTime.split(":")[1]));
		endDate.setSeconds(59);

		return startDate <= currentDate && currentDate <= endDate;
	}
}
